import { z } from 'zod';

import { emailSchema, passwordSchema } from '@web/utils';

export const resetPasswordSchema = z
  .object({
    email: emailSchema,
    code: z.string({ error: 'Code is required' }).min(1, 'Code is required'),
    new_password: passwordSchema,
    confirm_new_password: passwordSchema,
    invite_code: z.string().optional(),
  })
  .refine((data) => data.new_password === data.confirm_new_password, {
    path: ['confirm_new_password'],
    message: 'Passwords must match',
  });

export type ResetPasswordSchema = z.infer<typeof resetPasswordSchema>;
